module.exports = "/_next/static/images/app-store-icon-d58fe9667fc832464be081fc15980d97.png";